import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { removeFromThisCollectionAction } from '../../../actions/spaces/Collections/RemoveFromThisCollectionAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { isCollectionSpace } from '../../../state/SpaceInfo';
import { ICollectionInfo } from '../../Collections/ICollectionInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RemoveFromThisCollectionAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.RemoveFromThisCollection,
  translateName: Messages.removeFromThisCollection,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return FeatureFlags.collectionsEnabled && isCollectionSpace(state.spaceInfo);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[], state: AppState) => {
    const collection = <ICollectionInfo> selectSpaceInfoItem(state);
    return CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(collection.owner)(state);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return removeFromThisCollectionAction(targetItems);
  }
};
